<template>
  <div id="sensorDetailInfo" class="animated fadeIn h-100">
    <b-row class="h-100">
      <b-col class="cont">
        <b-row class="h-100">
          <b-col class="col-12">
            <b-card
              class="h-100 default-border1"
              body-class="h-100 p-0"
              header-tag="header"
            >
              <h6 slot="header">
                센서 상세 정보
                <!-- <label class="autoRefresh"><i class="fa fa-repeat ftsz14"></i></label>
                <b-form-select class="autoRefresh" :options="autoRefreshOptions" v-model="autoRefresh" @change="startRefreshTimer"></b-form-select> -->
              </h6>
              <div class="searchBox h60 p15">
                <div>
                  <label>프로젝트</label>
                  <vue-select
                    class="select-container w180"
                    v-model="search.projectid"
                    :options="search.projectOptions"
                    @input="getStidList"
                    :reduce="(a) => a.value"
                    label="text"
                    :clearable="false"
                    required
                  >
                  </vue-select>
                  <label>구조물</label>
                  <vue-select
                    class="select-container w180"
                    v-model="search.stid"
                    :options="search.stidOptions"
                    :reduce="(a) => a.value"
                    label="text"
                    :clearable="false"
                    required
                  >
                  </vue-select>
                  <label>디바이스 타입</label>
                  <b-form-select
                    v-model="search.devType"
                    :options="search.devTypeOptions"
                  ></b-form-select>
                  <label>디바이스</label>
                  <b-form-input v-model="search.devName"></b-form-input>
                  <label>센서 이름</label>
                  <b-form-input v-model="search.sensorAlias"></b-form-input>
                  <label>상태</label>
                  <b-form-select
                    v-model="search.state"
                    :options="search.stateOptions"
                  ></b-form-select>
                </div>
                <div>
                  <b-button class="searchBtn" @click="getSensorList"
                    >조회</b-button
                  >
                </div>
              </div>
              <ag-grid-vue
                class="ag-theme-balham sensorDetailGrid"
                :gridOptions="sensorGridOptions"
              ></ag-grid-vue>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- 센서 데이터 차트 Modal -->
    <b-modal
      id="sensorDataChartModal"
      :title="sensorData.title"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <sensor-data-chart-modal
        :defaultInfo="sensorData.defaultInfo"
      ></sensor-data-chart-modal>
    </b-modal>
    <!-- GNSS 센서 데이터 차트 Modal -->
    <b-modal
      id="gnssSensorDataChartModal"
      :title="sensorData.title"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <gnss-sensor-data-chart-modal
        :defaultInfo="sensorData.defaultInfo"
      ></gnss-sensor-data-chart-modal>
    </b-modal>
    <!-- 3축 가속도 센서 데이터 차트 Modal -->
    <b-modal
      id="ThreeAxisAccSensorDataChartModal"
      :title="sensorData.title"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <three-axis-acc-sensor-data-chart-modal
        :defaultInfo="sensorData.defaultInfo"
      ></three-axis-acc-sensor-data-chart-modal>
    </b-modal>
    <!-- 센서 데이터 현황 차트 Modal -->
    <b-modal
      id="sensorDataStatChartModal"
      :title="sensorDataStat.title"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <sensor-data-stat-chart-modal
        :defaultInfo="sensorDataStat.defaultInfo"
      ></sensor-data-stat-chart-modal>
    </b-modal>
    <!-- 센서 상세 정보 Modal -->
    <b-modal
      id="sensorDetailModal"
      title="센서 상세 정보"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <sensor-detail-modal
        :defaultInfo="sensorDetailDefInfo"
      ></sensor-detail-modal>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import comboRenderer from "../common/cellComboRenderer";
import btnRenderer from "../common/cellBtnRenderer";
import utils from "../common/utils";
import { AgGridVue } from "ag-grid-vue";
// import moment from 'moment'
import SensorDataChartModal from "./SensorDataChartModal";
import GnssSensorDataChartModal from "./GnssSensorDataChartModal";
import ThreeAxisAccSensorDataChartModal from "./ThreeAxisAccSensorDataChartModal";
import SensorDataStatChartModal from "./SensorDataStatChartModal";
import SensorDetailModal from "./SensorDetailModal";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    AgGridVue,
    SensorDataChartModal,
    GnssSensorDataChartModal,
    ThreeAxisAccSensorDataChartModal,
    SensorDataStatChartModal,
    SensorDetailModal,
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getCenterBus",
      "getUserId",
      "getUserAuth",
      "getTreeGridApi",
      "getAlertOptions",
      "getConfirmOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
    ]),
  },
  data() {
    return {
      isFirstCall: true,
      search: {
        projectid: null,
        projectOptions: [{ value: null, text: "전체" }],
        stid: null,
        stidOptions: [{ value: null, text: "전체" }],
        devType: null,
        devTypeOptions: [{ value: null, text: "전체" }],
        devName: null,
        sensorAlias: null,
        state: null,
        stateOptions: [
          { value: null, text: "전체" },
          { value: "O", text: "정상" },
          { value: "X", text: "장애" },
        ],
      },
      autoRefreshOptions: [
        { value: null, text: "없음" },
        { value: 10000, text: "10s" },
        { value: 30000, text: "30s" },
        { value: 60000, text: "60s" },
      ],
      autoRefresh: 60000,
      refreshTimer: null,
      sensorGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        enableColResize: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      sensorData: {
        title: "센서 실시간 차트",
        defaultInfo: {},
      },
      sensorDataStat: {
        title: "센서 데이터 현황",
        defaultInfo: {},
      },
      sensorDetailDefInfo: {},
    };
  },
  created() {
    this.getDefaultCodes();
    this.getProjectList();
    if (Object.keys(this.$route.params).length !== 0) {
      this.search.stid = this.$route.params.stid;
    }
  },
  beforeMount() {
    this.sensorGridOptions.columnDefs = [
      { headerName: "센서IDX", field: "sensoridx", hide: true },
      { headerName: "번호", field: "rownum", width: 90, hide: true },
      { headerName: "구조물 ID", field: "stid", hide: true },
      { headerName: "구조물 이름", field: "stname", width: 150 },
      {
        headerName: "타입",
        field: "devicetype",
        width: 110,
        cellRendererFramework: comboRenderer,
        cellRendererParams: {
          values: [],
        },
      },
      { headerName: "디바이스ID", field: "deviceid", width: 125 },
      { headerName: "CH#", field: "channel", width: 90 },
      {
        headerName: "센서 타입",
        field: "sensortype",
        width: 140,
        cellRendererFramework: comboRenderer,
        cellRendererParams: {
          values: [],
        },
      },
      { headerName: "모델", field: "sensormodel", width: 140 },
      { headerName: "센서 이름", field: "sensoralias", width: 160 },
      { headerName: "설치 장소", field: "instlloc" },
      {
        headerName: "상태",
        field: "state",
        width: 90,
        cellRendererFramework: comboRenderer,
        cellRendererParams: {
          values: [
            { value: "O", text: "●" },
            { value: "X", text: "●" },
            { value: "-", text: "-" },
          ],
        },
        cellStyle: (params) => {
          if (params.value === "O") {
            return {
              color: "#0f0",
              "font-size": "40px !important",
              display: "block",
              "line-height": "23px !important",
            };
          } else if (params.value === "X") {
            return {
              color: "#f00",
              "font-size": "40px !important",
              display: "block",
              "line-height": "23px !important",
            };
          }
        },
      },
      { headerName: "현재값", field: "curvalue", width: 120 },
      {
        headerName: "차트",
        field: "chart",
        width: 95,
        cellRendererFramework: btnRenderer,
        cellRendererParams: {
          evtBus: this.getCenterBus,
          emitEvtName: "showSensorChartData",
          btnText: null,
          iconYn: true,
          iconClass: "fa fa-line-chart",
          backgroundColor: "#ff8c00",
          borderColor: "#ff8c00",
          color: "#fff",
          disableCaseCol: "devicetype",
          disableCaseValues: ["11"],
        },
      },
      {
        headerName: "데이터 현황",
        field: "dataStat",
        width: 120,
        cellRendererFramework: btnRenderer,
        cellRendererParams: {
          evtBus: this.getCenterBus,
          emitEvtName: "showDataStatChart",
          btnText: null,
          iconYn: true,
          iconClass: "fas fa-database",
          backgroundColor: "#0071bb",
          borderColor: "#054d95",
          color: "#fff",
        },
      },
      {
        headerName: "상세보기",
        field: "curvalue",
        width: 100,
        cellRendererFramework: btnRenderer,
        cellRendererParams: {
          evtBus: this.getCenterBus,
          emitEvtName: "showSensorDetailData",
          btnText: null, // 'More',
          iconYn: true,
          iconClass: "fas fa-info",
          backgroundColor: "#7367f0", // '#1da1f2', // '#0653a1',
          borderColor: "#7367f0",
          color: "#fff",
        },
      },
    ];
  },
  mounted() {
    // 사용자가 가진 센서 전체 조회
    this.getSensorList();
    this.getCenterBus.$on("showSensorChartData", (param) => {
      this.openChartData(param);
    });
    this.getCenterBus.$on("showDataStatChart", (param) => {
      this.openDataStatChart(param);
    });
    this.getCenterBus.$on("showSensorDetailData", (param) => {
      this.getSensorDetailInfo(param);
    });
    this.startRefreshTimer(this.autoRefresh);
    this.getCenterBus.$on("selectedValue", (param) => {
      this.search.stid = param;
    });
  },
  destroyed() {
    this.getCenterBus.$off("showSensorChartData");
    this.getCenterBus.$off("showDataStatChart");
    this.getCenterBus.$off("showSensorDetailData");
    this.getCenterBus.$off("selectedValue");
    this.stopRefreshTimer();
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setConfirmTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
    ]),
    getDefaultCodes() {
      var reqBody = {
        codegrp: "devicetype,sensortype",
      };
      this.$http
        .post("/comn/code", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var value = [];
            let index = 0;
            // 장비 상태
            value = [{ value: null, text: "선택" }];
            var devicetype = res.data.devicetype;
            for (let i = 0; i < devicetype.length; i++) {
              value.push({
                value: devicetype[i].cd,
                text: devicetype[i].nm,
              });
            }
            this.search.devTypeOptions = value;
            for (
              index = 0;
              index < this.sensorGridOptions.columnDefs.length;
              index++
            ) {
              if (
                this.sensorGridOptions.columnDefs[index].field === "devicetype"
              )
                break;
            }
            this.sensorGridOptions.columnDefs[index].cellRendererParams.values =
              value.slice(1);
            value = [];
            var sensortype = res.data.sensortype;
            for (let i = 0; i < sensortype.length; i++) {
              value.push({
                value: sensortype[i].cd,
                text: sensortype[i].nm,
              });
            }
            for (
              index = 0;
              index < this.sensorGridOptions.columnDefs.length;
              index++
            ) {
              if (
                this.sensorGridOptions.columnDefs[index].field === "sensortype"
              )
                break;
            }
            this.sensorGridOptions.columnDefs[index].cellRendererParams.values =
              value;
            this.sensorGridOptions.api.setColumnDefs(
              this.sensorGridOptions.columnDefs
            );
            this.sensorGridOptions.api.sizeColumnsToFit();
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/stat/getProjectList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "전체" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname,
              });
            }
            this.search.projectOptions = options;
            console.log(this.getSelectedDataProjectid);
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              console.log("selected p id", this.getSelectedDataProjectid);
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "전체" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "전체" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text: data[i].stname,
              });
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
                console.log("selected s id", this.getSelectedDataStid);
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.isFirstCall = false;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getSensorList() {
      var reqBody = {
        projectid: this.search.projectid,
        stid: this.search.stid,
        devicetype: this.search.devType,
        deviceid: this.search.devName,
        sensoralias: this.search.sensorAlias,
        state: this.search.state,
      };
      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);

      this.$http
        .post("/sensor/getSensorList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var sensorlist = res.data.data;
            this.sensorGridOptions.api.setRowData(sensorlist);
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    openChartData(param) {
      if (param.state !== "O") {
        this.setAlertTitle("센서 상태 비정상");
        this.$bvModal
          .msgBoxOk(
            "센서가 정상 상태가 아니므로 차트 확인이 불가합니다.",
            this.getAlertOptions
          )
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.sensorData.title = param.sensoralias + " 실시간 차트";
        this.sensorData.defaultInfo = {
          devtype: param.devicetype,
          devid: param.deviceid,
          sensoridx: param.sensoridx,
        };
        if (utils.isGNSS(param.devicetype)) {
          this.$bvModal.show("gnssSensorDataChartModal");
        } else if (
          utils.is3axis(param.sensormodel) ||
          utils.isCCD(param.devicetype)
        ) {
          this.$bvModal.show("ThreeAxisAccSensorDataChartModal");
        } else {
          this.$bvModal.show("sensorDataChartModal");
        }
      }
    },
    openDataStatChart(param) {
      this.sensorDataStat.title = param.sensoralias + " 데이터 현황";
      this.sensorDataStat.defaultInfo = {
        devid: param.deviceid,
      };
      this.$bvModal.show("sensorDataStatChartModal");
    },
    getSensorDetailInfo(param) {
      this.sensorDetailDefInfo = {
        devicetype: param.devicetype,
        deviceid: param.deviceid,
        channel: param.channel,
        sensortype: param.sensortype,
      };
      this.$bvModal.show("sensorDetailModal");
    },
    startRefreshTimer(param) {
      if (param === null) {
        this.stopRefreshTimer();
      } else if (this.refreshTimer === null) {
        this.refreshTimer = setInterval(() => {
          this.getSensorList();
        }, param);
      } else {
        this.stopRefreshTimer();
        this.startRefreshTimer(param);
      }
    },
    stopRefreshTimer() {
      if (this.refreshTimer !== null) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
  },
};
</script>

<style lang="scss">
#sensorDetailInfo {
  padding: 15px;
  & .card {
    & .card-header {
      padding: 10px 15px;
      & h6 {
        font-size: 14px;
        line-height: unset;
        & label.autoRefresh {
          position: absolute;
          top: 7px;
          right: 92px;
          margin-bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 24px;
        }
        & select.autoRefresh {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 7px;
          right: 7px;
          width: 75px;
          height: 25px;
          padding: 0px 28px 1px 12px;
          border: 1px solid #404656;
          border-radius: 5px;
        }
      }
    }
  }
  & .searchBox {
    justify-content: space-between;
  }
  & div.ag-theme-balham.sensorDetailGrid {
    height: calc(100% - 60px) !important;
    & .ag-root .ag-body .ag-body-viewport {
      overflow-x: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/SensorInfo.vue